import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { BetaPill } from '@/components/Pill/BetaPill';
import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { useDisplayInSituPages } from '@/pages/shared/uploads/hooks/useDisplayUploadsPage';
import { buildPath } from '@/utils/buildPath';

import { MediaMapCards } from './components/MediaMapCards';

export const MediaMapsPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  const pathSet = usePathSet();

  const { displayMediaMapPage } = useDisplayInSituPages();

  if (!displayMediaMapPage) {
    return <Navigate to={pathSet.home} replace />;
  }

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: (
          <Stack direction='row' spacing={4} centerMain>
            {t('navbar.mediaMaps')} <BetaPill />
          </Stack>
        ),
        backPath: buildPath(pathSet.uploads),
      }}
    >
      <Stack spacing={8} direction='row' className='flex-wrap w-full'>
        <MediaMapCards />
      </Stack>
    </SignedInPageLayout>
  );
};
